import getCart from './getCart';
import updateCartCount from './updateCartCount';

const changeCart = async (lineItemKey, qty) => {
  const item = {
    id: lineItemKey,
    quantity: qty
  };

  try {
    const change = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(item)
    });
    const cart = await getCart();
    updateCartCount(cart.item_count);
    return await change.json();
  } catch (err) {
    console.error('Add to cart error:', err);
  }
};

export default changeCart;
